import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import logger from "redux-logger";
import storage from 'redux-persist/lib/storage';
import rootReducer from "../rootReducer/rootReducer";

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // disable if using non-serializable data (like Dates or Maps)
        }).concat(logger),
    devTools: true,
});

export const persistor = persistStore(store);
export default store;